import React from "react";
import SickMarkingPerDay from "./SickMarkingPerDay";
import HalfDoughnutChart from "../../../../CHARTS/HalfDoughnutChart";
import DispatchChart from "./DispatchCharts";
import TerminalDetentionNkj from "./TerminalDetentionNkj";
const DispatchAndTerminalDetentionMaster = ({
  data,
  selectedFy,
  selectedFilters,
}) => {
  return (
    <div>
      <div className="newUiBodyNM me-2">
        <SickMarkingPerDay data={data} />
      </div>
      {/* <div className="newUiBodyNM me-2">
        <DispatchChart data={data} />
      </div>{" "} */}
      <div className="newUiBodyNM me-2">
        <TerminalDetentionNkj
          data={data}
          selectedFy={selectedFy}
          selectedFilters={selectedFilters}
        />
      </div>
    </div>
  );
};
export default DispatchAndTerminalDetentionMaster;
